import { InputField } from '@synergy-marine-group/synergy-ui';
import React from 'react';

const InputFieldComponent = ({
  field, // { name, value, onChange, onBlur }
  requiredField,
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <div className={`${requiredField ? 'required-field' : ''}`}>
    <InputField autoComplete="off" {...field} {...props} />
    {touched[field.name] && errors[field.name] && <div className="error text-xs mt-1">{errors[field.name]}</div>}
  </div>
);

export default InputFieldComponent;
